import { render, staticRenderFns } from "./VerSala.vue?vue&type=template&id=8c314e80&scoped=true"
import script from "./VerSala.vue?vue&type=script&lang=js"
export * from "./VerSala.vue?vue&type=script&lang=js"
import style0 from "./VerSala.vue?vue&type=style&index=0&id=8c314e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c314e80",
  null
  
)

export default component.exports